import AssessmentIcon from '@mui/icons-material/Assessment';
import { Typography } from '@mui/material';

function ReportsWidget() {
  return (
    <div>
      <Typography sx={{ fontSize: 14 }} color="secondary" gutterBottom>
        <AssessmentIcon /> Reports
      </Typography>
    </div>
  );
}

export default ReportsWidget;
